import { onTransitionEnd } from '../../helpers/ontransitionend';
import { debounce } from 'throttle-debounce';

export default class ComparisionTableSlider {
    constructor() {
        this.$container = document.querySelector('.comparison-table');
        this.$list = document.querySelector('.comparison-table__list');
        this.$inner = document.querySelector('.comparison-table__inner');
        this.$listFixed = document.querySelector('.comparison-table__list--fixed');
        this.$navigation = this.$container.querySelectorAll('.comparison-table__btn-slide');
        this.$btnRight = document.querySelector('.comparison-table__btn-slide--next');
        this.options = {
            itemsPerSlide: 1
        };

        this.isSliding = false;

        this.prevSlideValue = null;

        this.init();
    }

    init() {
        this.toggleNavigation();
        this.eventSlideItems();
        this.eventWindowResize();
        this.eventScroll();
    }

    slide(direction) {
        const slideDistance = this.calculateDistance(direction);

        if (slideDistance === this.prevSlideValue) {
            this.$container.classList.remove('comparison-table--sliding');
            this.isSliding = false;
            return;
        }

        this.prevSlideValue = slideDistance;

        this.$list.style.transform = `translateX(${slideDistance}px)`;
        this.$listFixed.style.transform = `translateX(${slideDistance}px)`;

        onTransitionEnd(this.$list).then(() => {
            this.$container.classList.remove('comparison-table--sliding');
            this.isSliding = false;
        });
    }

    calculateDistance(direction) {
        const size = this.$list.querySelector('.comparison-table__col').offsetWidth * this.options.itemsPerSlide;
        const currentShiftValue = window.getComputedStyle(this.$list).getPropertyValue('transform');
        const currentPos = currentShiftValue === 'none' ? 0 : parseInt(currentShiftValue.split(', ')[4]);
        const visibleElements = Math.floor(this.$list.clientWidth / size);
        const innerPadding = this.$list.clientWidth - (visibleElements * size) - 16; // extra space from not entirely visible column on edge
        const newPos = currentPos + (size * (direction === 'prev' ? 1 : -1));

        if (newPos > 0) { // left border
            return 0;
        } else if (Math.abs(newPos) >= (size * this.$list.children.length - size * visibleElements)) { // right border
            return (size * this.$list.children.length - size * visibleElements) * -1 + innerPadding;
        } else {
            return newPos;
        }
    }

    /**
     * toggle navigation. Where there is nothing to slide pagination should be hidden
     */
    toggleNavigation() {
        const $cols = this.$list.querySelectorAll('.comparison-table__col');
        const sumColsWidth = [...$cols].reduce((acc, $col) => acc += $col.offsetWidth, 0);

        this.$navigation.forEach(($btn) => {
            $btn.style.display = sumColsWidth <= this.$list.offsetWidth ? 'none' : 'block';
        });
    }

    eventWindowResize() {
        window.addEventListener('resize', debounce(200, () => {
            if (this.$container.classList.contains('comparison-table--expanded')) {
                this.setNextButtonPosition();
            }
        }));
    }

    setNextButtonPosition() {
        this.$btnRight.style.marginLeft = (this.$inner.getBoundingClientRect().width + 2) + 'px';
    }

    eventSlideItems() {
        this.$navigation.forEach(($btn) => {
            $btn.addEventListener('click', () => {
                if (this.isSliding) {
                    return;
                }

                this.$container.classList.add('comparison-table--sliding');
                this.isSliding = true;

                this.slide($btn.classList.contains('prev') ? 'prev' : 'next');
            });

            $btn.addEventListener('dbclick', (e) => e.preventDefault());
        })
    }

    eventScroll() {
        window.addEventListener('scroll', () => {
            let listPosition = this.$list.getBoundingClientRect().top;

            if (this.$container.classList.contains('comparison-table--expanded')) {
                if (listPosition <= 0) {
                    this.$navigation.forEach(btn => {
                        btn.classList.add('comparison-table__btn-slide--fixed');
                    })
                } else {
                    this.$navigation.forEach(btn => {
                        btn.classList.remove('comparison-table__btn-slide--fixed');
                    })
                }
            } else {
                this.$navigation.forEach(btn => {
                    btn.classList.remove('comparison-table__btn-slide--fixed');
                })
            }
            this.setNextButtonPosition();
        });

    }
}


// WEBPACK FOOTER //
// ./front/treasurybond/js/components/comparision-table/ComparisionTableSlider.js